<div fxLayout="row" fxLayoutAlign="center start" class="message">
    <div fxFlex.gt-md="100" fxFlex.gt-sm="100" fxFlex="100">
        <mat-sidenav-container class="sidenav-container"
            [ngClass]="{ 'side-panel-opened': sidePanelOpened, 'side-panel-closed': !sidePanelOpened }">
            <mat-sidenav #chatnav [mode]="isOver() ? 'over' : 'side'" [opened]="!isOver()"
                (open)="sidePanelOpened = true" (close)="sidePanelOpened = false">
                <mat-toolbar color="primary" class="no-shadow">
                    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
                        <ngx-avatar class="m-r-10" size="40" [name]="loggedInUser.name" bgColor="#f2f4f8" fgColor="#000"
                            initialsSize="2">
                        </ngx-avatar>
                        <span class="m-t-0 font-14">
                            {{loggedInUser.name}}
                        </span>
                    </div>
                </mat-toolbar>
                <mat-nav-list class="nav-list" *ngIf="isLoadData" infiniteScroll [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="500" (scrolled)="onScroll()" [scrollWindow]="false">
                    <mat-list-item [ngClass]="{'selected-item': selectedParticipant.id === participant.id}"
                        (click)="onSelect(participant)"
                        *ngFor="let participant of participants; let i=index; trackBy: trackByMethod">
                        <span matLine fxLayout="row" fxLayoutAlign="start center">
                            <ngx-avatar *ngIf="participant.messages&&participant.messageCount"
                                [matBadge]="participant.messageCount" matBadgeColor="accent" class="m-r-10" size="40"
                                name="{{participant.fname}} {{participant.lname}}" bgColor="#f2f4f8" fgColor="#000"
                                initialsSize="2">
                            </ngx-avatar>
                            <ngx-avatar *ngIf="!participant.messageCount" class="m-r-10" size="40"
                                name="{{participant.fname}} {{participant.lname}}" bgColor="#f2f4f8" fgColor="#000"
                                initialsSize="2">
                            </ngx-avatar>
                            <h3 matLine> {{participant.fname}} {{participant.lname}} </h3>
                        </span>
                    </mat-list-item>
                </mat-nav-list>

                <div *ngIf="!isLoadData">
                    <div *ngFor="let message of fakePatients;" fxLayout="row" fxLayoutAlign="center center">
                        <div fxFlex="25">
                            <ngx-skeleton-loader count="1" appearance="circle"
                                [theme]="{height: '50px', width: '50px'}"></ngx-skeleton-loader>
                        </div>
                        <div fxFlex="70">
                            <ngx-skeleton-loader count="1" [theme]="{height: '40px', margin: '0px'}">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-toolbar class="bg-success no-shadow chat-right-panel" color="warn">
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
                    <button *ngIf="selectedParticipant" (click)="chatnav.toggle()" class="mr-1" mat-icon-button>
                        <mat-icon>short_text</mat-icon>
                    </button>
                    <span class="top-avatar m-r-10">
                        <ngx-avatar *ngIf="selectedParticipant" size="40" name="{{selectedParticipant.fname}} {{selectedParticipant.lname}}"
                            bgColor="#f2f4f8" fgColor="#000" initialsSize="2">
                        </ngx-avatar>
                    </span>
                    <div fxFlex>
                        <div class="font-14" *ngIf="selectedParticipant">{{selectedParticipant.fname}} {{selectedParticipant.lname}}</div>
                    </div>
                    <div fxFlex="5" class="pointer" (click)="onClosePopup()" fxLayoutAlign="center center">
                        <mat-icon>clear</mat-icon>
                    </div>
                </div>
            </mat-toolbar>
            <div class="p-10 bg-white chat-bubble-container" *ngIf="selectedParticipant.id">
                <app-patient-engagement [patientId]="selectedParticipant.id" [patientDetails]="selectedParticipant">
                </app-patient-engagement>
            </div>
            <div *ngIf="!selectedParticipant && isLoadData">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img width="200" src="assets/images/patient-engagement/no-messages.png">
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <h3>There are no new messages</h3>
                </div>
            </div>
        </mat-sidenav-container>
    </div>
</div>